import { render, staticRenderFns } from "./banner2.vue?vue&type=template&id=ff1a0c50&scoped=true"
import script from "./banner2.vue?vue&type=script&lang=js"
export * from "./banner2.vue?vue&type=script&lang=js"
import style0 from "./banner2.vue?vue&type=style&index=0&id=ff1a0c50&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1a0c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1a0c50')) {
      api.createRecord('ff1a0c50', component.options)
    } else {
      api.reload('ff1a0c50', component.options)
    }
    module.hot.accept("./banner2.vue?vue&type=template&id=ff1a0c50&scoped=true", function () {
      api.rerender('ff1a0c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/bannerTemplate/banner2.vue"
export default component.exports